import React, { useState, useEffect } from "react";
import { generateContactBattlecardDetails, getContactBattleCard } from "../../../../../services/iqApiV2";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import { WSS_URL } from "../../../../../config/apiConfig";
import ExpandableList from "../../Opportunities/CardTabs/expandableParagraph/ExpandableList";
import ExpandableParagraph from "../../Opportunities/CardTabs/expandableParagraph/ExpandableParagraph";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import HoverTagList from "./hoverToggleList/HoverTagList";
import SimpleExpandableList from "../../Opportunities/CardTabs/expandableParagraph/SimpleExpandableList";
import { AlertOctagon } from "react-feather";
import "./BattleCardDetails.css";
import ChipWithEllipse from "../../Opportunities/ChipWithEllipse";
import GenericTagComp from "../../../genericComponents/tag/GenericTagComp";

const renderValue = (value, key = null) => {
  const formatKey = (k) => {
    const mapp = {
      opportunity_where: "",
      unmet_need: "Unmet Need / Pain Point",
      objection: "Most Likely Objection",
      rebuttal: "",
    };
    if (mapp?.[k]) {
      return mapp?.[k];
    }
    return k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  if (typeof value === "string") {
    const content = value;

    return (
      <div className="bc_kv_row" key={key || value}>
        {key !== "rebuttal" ? (
          <>
            {key && (
              <span className="bc_kv_label">
                <strong>{formatKey(key)}:</strong>
              </span>
            )}
            <div className="bc_kv_value">
              {key === "opportunity_description" ? (
                <p className="bc_body_md">
                  <ExpandableParagraph text={content} wordLimit={25} />
                </p>
              ) : (
                <p className="bc_body_md">{content}</p>
              )}
            </div>
          </>
        ) : (
          <div className="bc_kv_value">
            <p className="bc_body_md">
              <span className="opp_bat_span">
                <span className="bc_semibold">{formatKey(key)}:</span>
              </span>{" "}
              {content}
            </p>
          </div>
        )}
      </div>
    );
  }

  if (Array.isArray(value)) {
    const hasObj = value.some((v) => typeof v === "object" && v !== null);
    return (
      <div className="bc_list_row" key={key}>
        {key && (
          <strong className="bc_kv_label bc_list_label">
            {formatKey(key)}:
          </strong>
        )}
        {key === "sub_signal" ? (
          <ExpandableList
            className="bc_list bc_list_expandable"
            items={value}
            renderItem={renderValue}
            visibleCount={1}
          />
        ) : (
          <ul
            className={`bc_list ${hasObj ? "bc_list_full" : "bc_list_compact"}`}
          >
            {value.map((item, idx) => (
              <li key={idx} className="bc_list_item">
                {renderValue(item)}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  if (typeof value === "object" && value !== null) {
    return (
      <div className="bc_nested_row" key={key}>
        {key && key !== "opportunity_where" && (
          <strong className="bc_kv_label">{formatKey(key)}:</strong>
        )}
        <div className="bc_nested_container">
          {Object.entries(value).map(([childKey, childVal]) =>
            renderValue(childVal, childKey)
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="bc_kv_row" key={key}>
      {key && <strong className="bc_kv_label">{formatKey(key)}:</strong>}
      <span className="bc_kv_value">{String(value)}</span>
    </div>
  );
};

function BattleCardDetails({
  contactName,
  linkedInUrl,
  contactOrg,
  sellerOrg,
  contactId,
  userId,
  setContactInfoDropDown,
  buList
}) {
  const TASK_ID = `tro_sidecard_contact_bc_${contactId}_${contactOrg}_${userId}_${sellerOrg}`;
  const { registerTask, getTaskData } = useTaskStatus();
  
  const taskData = getTaskData(TASK_ID)||{};
  const [apiData,setApiData] = useState(null)
  const contactDetail =   taskData?.result || apiData?.result;
  console.log("contactDetail", taskData , apiData, taskData?.result || apiData?.result)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await generateContactBattlecardDetails(
          contactName,
          linkedInUrl,
          contactOrg,
          sellerOrg
        );
        
        registerTask(TASK_ID, `${WSS_URL}/${response}`);
      } catch (error) {
        console.error("Error fetching battlecard details:", error);
      }
    };


      const fetchDataPregen = async () => {
      try {
        const response = await getContactBattleCard(
          contactName,
          linkedInUrl,
          contactOrg,
          sellerOrg
        );
        
         if(!response?.result){ 
           if (localStorage.getItem(TASK_ID)) {
            
             registerTask(TASK_ID, localStorage.getItem(TASK_ID));
             taskData.status = getTaskData(TASK_ID)?.status;
             taskData.result =  getTaskData(TASK_ID)?.result;
              console.log("taskData::inner1",taskData)
           }else{
            fetchData();
           }
            
         }else{
          setApiData(response);
         }
      } catch (error) {
        console.error("Error fetching battlecard details:", error);
        return {status:"failed",result:false}
      }
    };

      fetchDataPregen()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactId, contactName, linkedInUrl, contactOrg, sellerOrg]);

console.log("taskData::",taskData,apiData) // here its still printing {}

  useEffect(() => {
    setContactInfoDropDown({});
    if (taskData?.status === "completed"||apiData?.status === "completed") {
      setContactInfoDropDown(contactDetail);
      
    }
    return ()=>{
      setContactInfoDropDown({});
    }
  }, [apiData?.status,taskData?.status, contactDetail?.bant_framework, setContactInfoDropDown]);

  if (taskData?.status === "failed") {
    return null;
  }

  if (taskData?.status !== "completed" && !apiData?.result) {
    return (
      <div className="bc_loader_container">
        <GeneratingLoader />
      </div>
    );
  }

  return (
    <section className="bc_root" aria-label="Battlecard Details">
      {/* Psychographic / Professional */}
       {false && <> <div className="bc_section_header">
         <h3 className="bc_heading_sm"> Business Units</h3> 
        <span className="bc_section_divider" />
      </div>
      <span style={{display:"flex",flexDirection:"row",gap:"0.2rem",flexWrap:"wrap"}}>{buList?.map((item)=><GenericTagComp text={item}/>)}</span></>}
     

      {/* Conversation Hooks */}
      <div className="bc_section_header">
        <h3 className="bc_heading_sm">Conversation Hooks</h3>
        <span className="bc_section_divider" />
      </div>
      <div className="bc_grid">
        {contactDetail?.hook_1 && (
          <article className="bc_card" tabIndex={0}>
            <header className="bc_card_header">
              <h4 className="bc_heading_xs">Hook 1</h4>
              <HoverTagList  disableBg={true} items={[{ title:<AlertOctagon style={{maxHeight:"1rem"}}/>, description:contactDetail?.hook_1_sources}]} />
            </header>
            <div className="bc_card_body bc_body_md">
              {contactDetail?.hook_1}
            </div>
          </article>
        )}
        {contactDetail?.hook_2 && (
          <article className="bc_card" tabIndex={0}>
            <header className="bc_card_header">
              <h4 className="bc_heading_xs">Hook 2</h4>
              <HoverTagList  disableBg={true} items={[{ title:<AlertOctagon style={{maxHeight:"1rem"}}/>, description:contactDetail?.hook_2_sources}]} />
            </header>
            <div className="bc_card_body bc_body_md">
              {contactDetail?.hook_2}
            </div>
          </article>
        )}
      </div>

      {/* Focus Areas */}
      <div className="bc_section_header">
        <h3 className="bc_heading_sm">Focus Areas</h3>
        <span className="bc_section_divider" />
      </div>
      {contactDetail?.focus_areas && <div className="bc_focus_area_container">
        <HoverTagList items={contactDetail?.focus_areas} customAlign={null}/>
      </div>}
    </section>
  );
}

export default BattleCardDetails;
